import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-create-template-dialogue',
  templateUrl: './create-template-dialogue.component.html',
  styleUrls: ['./create-template-dialogue.component.css']
})
export class CreateTemplateDialogueComponent implements OnInit {
  public newFolderTitle;

  constructor(
    public dialogRef: MatDialogRef<CreateTemplateDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  updateNewFolderName(ev, name) {
    if (ev.which == 13) {
      this.onYesClick(name);
    }
  }

  onYesClick(name) {
    this.dialogRef.close(name);
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/create-template-dialogue/create-template-dialogue.component.ts